/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { LoanApiModel } from '../api-models/loan';
// @ts-ignore
import { LoanInstallmentPaymentOperationRequestDataApiModel } from '../api-models/loan-installment-payment-operation-request-data';
// @ts-ignore
import { LoansPaginatedListApiModel } from '../api-models/loans-paginated-list';
// @ts-ignore
import { MessageResponseApiModel } from '../api-models/message-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ClientApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root'
})
export class LoansApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: ClientApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Return loan info
   * @endpoint get /loans/{loan_id}
   * @param loanId Loan ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientLoanGet(
    loanId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LoanApiModel>;
  public incustControllersClientClientLoanGet(
    loanId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<LoanApiModel>>;
  public incustControllersClientClientLoanGet(
    loanId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<LoanApiModel>>;
  public incustControllersClientClientLoanGet(
    loanId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (loanId === null || loanId === undefined) {
      throw new Error(
        'Required parameter loanId was null or undefined when calling incustControllersClientClientLoanGet.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/loans/${this.configuration.encodeParam({
      name: 'loanId',
      value: loanId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<LoanApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Loan installment payment process
   * @endpoint post /loans/{loan_id}/installment_payments/{installment_payment_id}/make
   * @param loanId Loan ID
   * @param installmentPaymentId Installment payment ID
   * @param data Loan installment payment operation data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientLoanInstallmentPaymentMake(
    loanId: string,
    installmentPaymentId: string,
    data: LoanInstallmentPaymentOperationRequestDataApiModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LoanApiModel>;
  public incustControllersClientClientLoanInstallmentPaymentMake(
    loanId: string,
    installmentPaymentId: string,
    data: LoanInstallmentPaymentOperationRequestDataApiModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<LoanApiModel>>;
  public incustControllersClientClientLoanInstallmentPaymentMake(
    loanId: string,
    installmentPaymentId: string,
    data: LoanInstallmentPaymentOperationRequestDataApiModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<LoanApiModel>>;
  public incustControllersClientClientLoanInstallmentPaymentMake(
    loanId: string,
    installmentPaymentId: string,
    data: LoanInstallmentPaymentOperationRequestDataApiModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (loanId === null || loanId === undefined) {
      throw new Error(
        'Required parameter loanId was null or undefined when calling incustControllersClientClientLoanInstallmentPaymentMake.'
      );
    }
    if (installmentPaymentId === null || installmentPaymentId === undefined) {
      throw new Error(
        'Required parameter installmentPaymentId was null or undefined when calling incustControllersClientClientLoanInstallmentPaymentMake.'
      );
    }
    if (data === null || data === undefined) {
      throw new Error(
        'Required parameter data was null or undefined when calling incustControllersClientClientLoanInstallmentPaymentMake.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/loans/${this.configuration.encodeParam({
      name: 'loanId',
      value: loanId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/installment_payments/${this.configuration.encodeParam({
      name: 'installmentPaymentId',
      value: installmentPaymentId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/make`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<LoanApiModel>(
      'post',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: data,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return a list of the user’s loans
   * @endpoint get /loans
   * @param page List page number
   * @param count Objects on page
   * @param loyaltyId Loyalty ID (null for disable filtering)
   * @param status Loan status (null for disable filtering)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientUserLoansList(
    page?: number,
    count?: number,
    loyaltyId?: string,
    status?:
      | 'created'
      | 'approved'
      | 'declined'
      | 'declined-first-installment'
      | 'issued'
      | 'canceled'
      | 'partially-repaid'
      | 'repaid',
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<LoansPaginatedListApiModel>;
  public incustControllersClientClientUserLoansList(
    page?: number,
    count?: number,
    loyaltyId?: string,
    status?:
      | 'created'
      | 'approved'
      | 'declined'
      | 'declined-first-installment'
      | 'issued'
      | 'canceled'
      | 'partially-repaid'
      | 'repaid',
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<LoansPaginatedListApiModel>>;
  public incustControllersClientClientUserLoansList(
    page?: number,
    count?: number,
    loyaltyId?: string,
    status?:
      | 'created'
      | 'approved'
      | 'declined'
      | 'declined-first-installment'
      | 'issued'
      | 'canceled'
      | 'partially-repaid'
      | 'repaid',
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<LoansPaginatedListApiModel>>;
  public incustControllersClientClientUserLoansList(
    page?: number,
    count?: number,
    loyaltyId?: string,
    status?:
      | 'created'
      | 'approved'
      | 'declined'
      | 'declined-first-installment'
      | 'issued'
      | 'canceled'
      | 'partially-repaid'
      | 'repaid',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'page',
      <any>page,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'count',
      <any>count,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'loyalty_id',
      <any>loyaltyId,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'status',
      <any>status,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/loans`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<LoansPaginatedListApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }
}
